import React from 'react';

//types
import { IIconRotatableProps } from 'assets/icons/IconProps';

export const ArrowTopRight = ({
  width = 16,
  height = 16,
  rotate = 0,
  stroke = '#DBDDE0',
}: IIconRotatableProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      d="M3.33203 11.7266L10.392 4.66659H5.9987V3.33325H12.6654V9.99992H11.332V5.60659L4.27203 12.6666L3.33203 11.7266Z"
      fill={stroke}
    />
  </svg>
);
